package com.essntl.features.request.ui.allrequest

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.request.domain.model.RequestFilterOptions
import com.essntl.features.request.domain.model.RequestModel

data class AllRequestState(
    val getAllRequest: PaginationState<RequestModel> = PaginationState(),
    val getAllProposal: State<List<ProposalModel>> = State(),
    val getAllProfile: State<List<ProfileModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val updateRequestLoading: List<String> = emptyList(),
    val getAllFilteredRequest: List<RequestModel> = emptyList(),
    val filterOptions: RequestFilterOptions = RequestFilterOptions(),
    val updateProposalOwnerLoading: List<String> = emptyList(),
) {
    val isLoading: Boolean
        get() = getAllRequest.isLoading || getAllArea.isLoading

    val isFailure: Boolean
        get() = getAllRequest.isFailure || getAllArea.isFailure
}
